export default __webpack_public_path__ + "static/media/1969.3dbf984b.png";